window.addEventListener('load', () => {
    let triggers = document.querySelectorAll('.dino-animate-trigger');
    let screenDino = document.querySelectorAll('.dino-animate-translate-y');
    let ogDino = document.getElementById('ogDino');
    let possiblePositions = ['tl-tr', 'tr-tl', 'tr-br','br-tr', 'br-bl', 'bl-br', 'bl-tl', 'tl-bl'];
    let activeDinoClones = 0;

    for (let trigger of triggers) {
        trigger.addEventListener('click', () => {

            if (activeDinoClones === 0) {
                for (let dino of screenDino) {
                    dino.classList.add('translate-y-[100px]');
                }
                setTimeout(() => {
                    document.getElementById('dinoGrowl').play();
                }, 500);
            }

            activeDinoClones = activeDinoClones + 1;
            const dinoClone = ogDino.cloneNode(true);
            document.body.appendChild(dinoClone);
            dinoClone.removeAttribute('id');

            const randomizedPosition = Math.floor(Math.random() * possiblePositions.length);
            const position = possiblePositions[randomizedPosition];

            dinoClone.classList.remove('hidden');
            dinoClone.classList.add('dino-position-' + position);
            setTimeout(() => {
                dinoClone.classList.add('dino-animate-' + position);
            }, 50);

            setTimeout(() => {
                dinoClone.remove();
                activeDinoClones = activeDinoClones - 1;
                if (activeDinoClones === 0) {
                    for (let dino of screenDino) {
                        dino.classList.remove('translate-y-[100px]');
                    }
                }
            }, 1900);
        });
    }
});